import React, { Fragment } from 'react';
import { translate } from '../Services/translation';

const sameCategory = (item, index, array) =>
    (index > 0 && array[index - 1].category === array[index].category) ||
    item.showAll;

const QuickSearchResult = ({ result, selectedItem, searchUrl }) => (
    <div className="quick-search-result">
        <ul className="quick-search-result__list">
            {result && result.map((item, index, array) => (
                <Fragment key={`${item.name}-${index}`}>
                    {item.category === 'NoHit' ||
                    sameCategory(item, index, array) ? null : (
                        <li className="quick-search-result__item quick-search-result__group-header">
                            {item.category}
                        </li>
                    )}
                    <li
                        className={`quick-search-result__item ${
                            selectedItem === index
                                ? 'quick-search-result__item--selected'
                                : ''
                        }`}
                    >
                        <a
                            className={
                                item.showAll
                                    ? 'quick-search-result__show-all'
                                    : `quick-search-result__link ${
                                            item.url
                                                ? ''
                                                : 'quick-search-result__link--disabled'
                                        }`
                            }
                            href={item.showAll ? searchUrl : item.url}
                        >
                            <div className="quick-search-result__image-wrapper">
                                {item.category === translate("quicksearchheader.products") && (
                                item.hasImage && item.imageSource ? (
                                    <div className="quick-search-result__image">
                                        <img src={item.imageSource} />
                                    </div>
                                ) : (
                                    <div className="quick-search-result__image">
                                        <img src="ui/images/placeholder-image.png" />
                                    </div>
                                )
                                )}
                                <div className="quick-search-result__name">{item.name}</div>
                            </div>
                            
                            {item.price && (
                                <div className="quick-search-result__price-wrapper">
                                    {item.price.oldPrice || item.price.campaignPrice ? (
                                        <Fragment>
                                            <div className="quick-search-result__old-price">{item.price.oldPrice}</div><div className="quick-search-result__campaign-price">{item.price.campaignPrice}</div>
                                        </Fragment>
                                    ) : (
                                            <div className="quick-search-result__price">{item.price.price}</div>
                                    )}
                                </div>
                            )}
                        </a>
                    </li>
                </Fragment>
                ))}
        </ul>
    </div>
);

export default QuickSearchResult;
